<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16"
        style="enable-background:new 0 0 16 16;" xml:space="preserve" aria-hidden="true">
        <g id="_1_Fire_RGB" transform="translate(-40.989 -35)">
            <path id="Exclusion_1" class="st3" d="M49,50.9c-1.6,0-3.1-0.4-4.4-1.3c-1.4-0.9-2.2-2.4-2.3-4c0-0.2,0-0.3,0-0.4
			c0.1-1.9,0.6-3.8,1.2-5.6c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.8,0.4,1.4,1.1,1.8,1.8c0.6-0.5,1.3-1.5,1.4-3.6
			c0-0.8,0-1.6-0.1-2.4c0-0.1,0-0.2,0.1-0.2c0,0,0.1,0,0.1,0l0,0l0,0c0,0,0.1,0,0.1,0c2.1,1.1,3.8,2.9,4.6,5.2
			c0.5-0.5,0.9-1.2,1.1-1.9c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0.1c1.7,1.8,2.7,4.2,2.6,6.7c0,0.2,0,0.4,0,0.6
			c0,1.6-0.8,3.1-2.1,4C52.2,50.6,50.6,51,49,50.9z M46.4,45C46.4,45,46.4,45,46.4,45c-0.1,0-0.2,0.1-0.2,0.1c-0.5,1-0.7,2-0.8,3.1
			c0.1,0.9,0.5,1.6,1.3,2.1c0.7,0.4,1.5,0.7,2.3,0.7c2.1,0,3.5-1.1,3.6-2.8c0-1.4-0.5-2.7-1.4-3.7c0,0-0.1-0.1-0.1-0.1
			c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.2-0.1,0.5-0.3,0.7c-0.5-1.1-1.3-2-2.4-2.6c0,0-0.1,0-0.1,0h0c0,0-0.1,0-0.1,0
			c-0.1,0-0.1,0.1-0.1,0.2c0,0,0.3,2.2-0.5,3c-0.2-0.3-0.4-0.6-0.7-0.8C46.5,45,46.4,45,46.4,45L46.4,45z" />
        </g>
    </svg>
</template>

<style scoped>
path {
    fill: white;
}
</style>
